import { caseTransformingAxios } from "@shared/v2/caseTransformingAxios";
import { useEffect, useState } from "react";

const usePortalUrl = () => {
  const [url, setUrl] = useState<string>("https://www.billingportal.com/s/brivity/login/password");

  useEffect(() => {
    caseTransformingAxios
      .get<{ portalUrl: string }>("/add_ons_billing/portal_url")
      .then((res) => setUrl(res.data.portalUrl))
      .catch(() => {});
  }, []);

  return url;
};

export default usePortalUrl;
